import axios from 'axios';
import {AuthService} from "./AuthService";
import {withMaintenanceDetection} from "../utils/maintenance";

export class UnAuthService {

    static getAxiosWithoutAuth = () => {
        return withMaintenanceDetection(axios.create({
            baseURL: AuthService.baseURL,
            timeout: 40000,
            validateStatus: function (status) {
                return status >= 200 && status <= 226 ;
            }
        }));
    };

    static login(email, password) {
        return UnAuthService.getAxiosWithoutAuth().post("users/login/", {
            "email": email,
            "password": password,
            "device_token": AuthService.getDeviceToken()
        }).then(res => {
            if (res.data && res.data.two_factor_required)
                return res;
            AuthService.setUserAndToken(res);
            return res;
        }).catch((error) => {
            throw error
        });
    }

    static twoFactorVerify(challengeId, code, rememberDevice) {
        return UnAuthService.getAxiosWithoutAuth().post("users/two_factor/verify/", {
            "challenge_id": challengeId,
            "code": code,
            "remember_device": !!rememberDevice
        }).then(res => {
            AuthService.setUserAndToken(res);
            if (res.data.device_token)
                AuthService.setDeviceToken(res.data.device_token);
            return res;
        }).catch((error) => {
            throw error
        });
    }

    static twoFactorResend(challengeId) {
        return UnAuthService.getAxiosWithoutAuth()
            .post("users/two_factor/resend/", {"challenge_id": challengeId})
            .then(res => res.data).catch((error) => { throw error });
    }

    static twoFactorFallbackEmail(challengeId) {
        return UnAuthService.getAxiosWithoutAuth()
            .post("users/two_factor/fallback_email/", {"challenge_id": challengeId})
            .then(res => res.data).catch((error) => { throw error });
    }

    static socialLogin(provider, tokenPayload) {
        const endpointByProvider = {
            google: "users/google_login/",
            gmail: "users/gmail_login/",
            linkedin: "users/linkedin_login/"
        };

        const endpoint = endpointByProvider[provider] || "users/social_login/";
        return UnAuthService.getAxiosWithoutAuth().post(endpoint, tokenPayload).then(res => {
            AuthService.setUserAndToken(res);
            return res;
        }).catch((error) => {
            throw error
        });
    }

    static register(user){
        return UnAuthService.getAxiosWithoutAuth().post("users/", user).then(res => {
            return res.data;
        }).catch((error) => {
            throw error
        });
    }

    static resetPassword(password, token) {
        return UnAuthService.getAxiosWithoutAuth().post( "users/reset_password/", {"token": token, "password": password}).then(res => {
            return res;
        }).catch((error) => {
            throw error
        });
    }

    static sendRecoveryLink(email) {
        return UnAuthService.getAxiosWithoutAuth().post( "users/send_recovery_link/", {"email": email}).then(res => {
            return res;
        }).catch((error) => {
            throw error
        });
    }

}
